import type transform from '../to/teachers';

export default (teachers: ReturnType<typeof transform>) => {
  if (teachers.length != new Set(teachers.map(x => x.id)).size)
    throw new Error('(Core::From::V2::Teachers) Teachers array have two or more teachers with the same ID');

  return teachers
    .map(x => {
      if (!x.id)
        throw new Error('(Core::From::V2::Teachers) Teacher id is undefined');

      return { ...x };
    });
};
